export default "__VITE_ASSET__DjexRMmJ__"